/*-----------------------------------------------------------------
- Components translations
-----------------------------------------------------------------*/

export default {
    uploader: {
        drag: {
            single  : 'ضع ملفك هنا!',
            multiple: 'اترك ملفاتك هنا!',
        },

        button: {
            small   : 'حدد الملف',
            single  : 'أو حدد ملفك',
            multiple: 'أو حدد ملفاتك',
        },

        add                         : 'ابحث عن الملف',
        dictRemoveFile              : 'حذف ملف',
        dictRemoveFileConfirmation  : 'هل أنت متأكد أنك تريد حذف الملف؟',
        dictCancelUpload            : 'لا تهتم!',
        dictUploadCanceled          : 'توقفت عملية التحميل!',
        dictCancelUploadConfirmation: 'هل أنت متأكد من إيقاف عملية التحميل؟',
        dictFileTooBig              : 'حجم الملف كبير ({filesize} ميغا بايت). الحد الأقصى لحجم الملف الذي يمكن إرساله هو {maxFileSize} ميغا بايت.',
        dictInvalidFileType         : 'لا يمكن تحميل ملف بهذا التنسيق.',
        dictResponseError           : 'اضطراب التواصل.',
        dictMaxFilesExceeded        : 'لا يمكنك تحميل أكثر من {maxFiles} من الملفات.',

        size          : 'ميغا بايت',
        uploading     : 'يتم تحميل ملفك.',
        stop_uploading: 'توقف عن التحميل',
    },

    date_picker: {
        addon: {
            date    : 'تاریخ',
            time    : 'وقت',
            datetime: 'تاریخ',
            year    : 'عام',
            month   : 'شهر',
        },
    },
};
